import { createFormAction } from 'redux-form-saga'

import { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE } from '../types/schedule-delays'

const selectRequest = (data) => {
  return {
    payload: {
      data,
    },
    type: SELECT_REQUEST,
  }
}

const selectSuccess = (data) => {
  return {
    payload: {
      data,
    },
    type: SELECT_SUCCESS,
  }
}

const selectFailure = (exception) => {
  return {
    payload: {
      exception,
    },
    type: SELECT_FAILURE,
  }
}

const insert = createFormAction('SCHEDULE_DELAYS_INSERT')

export { selectRequest, selectSuccess, selectFailure, insert }
